import { useMemo } from 'react';
import { useAuth } from './useAuth';

interface ApiConfig {
  baseURL: string;
  headers: Record<string, string>;
  timeout: number;
}

interface UseApiConfigOptions {
  baseURL?: string;
  timeout?: number;
  additionalHeaders?: Record<string, string>;
}

export const useApiConfig = (options: UseApiConfigOptions = {}): ApiConfig => {
  const {
    baseURL = '',
    timeout = 30000, // 30 seconds default
    additionalHeaders = {},
  } = options;

  const auth = useAuth();

  const config = useMemo(() => {
    const defaultHeaders: Record<string, string> = {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      ...additionalHeaders,
    };

    // Add authentication headers if available.
    // Dex (on-demand envs) needs the id_token; OneLogin uses the access_token.
    const forwardIdToken = process.env.REACT_APP_FORWARD_TOKEN === 'id';
    const token = forwardIdToken ? auth?.idToken : auth?.accessToken;
    if (token) {
      defaultHeaders['Authorization'] = `Bearer ${token}`;
    }

    return {
      baseURL,
      headers: defaultHeaders,
      timeout,
    };
  }, [baseURL, timeout, additionalHeaders, auth]);

  return config;
};
